<script setup>
import { onMounted, onBeforeUnmount} from 'vue'

onMounted(() => {
})

onBeforeUnmount(() => {
})
</script>

<template>
  <div class="card m-0 mb-1 h-100">
    <!-- <div class="card-header py-0 bg-dark-subtle text-center">出力条件</div> -->
    <div class="card-body p-0 h-100">
      <div class="row h-100">
        <!-- 外部URLのiframeは一時的にコメントアウト -->
        <!-- <div class="ratio ratio-1x1">
          <iframe src="https://famisuke.mtc-sams.org/costmanager/summary"></iframe>
        </div> -->
        <div class="p-3">
          <p class="text-muted">生育管理機能は現在準備中です</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
